import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
// Inicializar middleware de auditoria LGPD
import './lib/auditMiddleware'
import { StrictMode } from 'react'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
